import React from "react";
import DOMPurify from "dompurify";

// Chamados antigos têm descrição em texto puro — sem tags, renderiza
// preservando quebras de linha em vez de tratar como HTML.
const looksLikeHtml = (value = "") => /<[a-z][\s\S]*>/i.test(value);

/**
 * `allowedTags` fecha a marcação numa lista própria e derruba TODOS os
 * atributos — é o modo usado pelo contrato, onde o texto é escrito por um
 * representante e lido pela carteira dele. Sem o parâmetro, vale o perfil html
 * do DOMPurify (o caso dos chamados, que aceitam link).
 */
const RichTextViewer = ({ html, className = "", allowedTags }) => {
  if (!html) return null;

  if (!looksLikeHtml(html)) {
    return <div className={`whitespace-pre-wrap ${className}`}>{html}</div>;
  }

  const config = allowedTags
    ? { ALLOWED_TAGS: allowedTags, ALLOWED_ATTR: [] }
    : { USE_PROFILES: { html: true }, ADD_ATTR: ["target", "rel"] };

  return (
    <div
      className={`rich-text-content ${className}`}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html, config) }}
    />
  );
};

export default RichTextViewer;
